import React, { Component } from 'react';
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
} from "@react-pdf/renderer";
import * as moment from "moment";
import "moment/locale/pt-br";

export default class PDFDetalhesEntrega extends Component {
    render() {
        return (
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.section}>
                        <View>
                            <Text style={{ fontWeight: 'bold', fontSize: 18, color: '#701B8C', marginBottom: 10 }}>
                                iFeira - Relatório de Entregas
                            </Text>
                            <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D', marginBottom: 10 }}>
                                Estabelecimento:
                                    <Text style={{ fontSize: 16, color: "#701B8C" }}>
                                    {"  "}{this.props.estabelecimento.nome_fantasia}
                                </Text>
                            </Text>
                            {this.props.entregador ? (
                                <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D', marginBottom: 10 }}>
                                    Entregador(es):
                                    <Text style={{ fontSize: 14, color: "#701B8C" }}>
                                        {"  "}
                                        {this.props.entregador ? this.props.entregador.map(e => (<Text>{e.label}, </Text>)) : null}
                                    </Text>
                                </Text>
                            ) : null}
                            <View style={{ borderTopWidth: 1, }}>
                                <Text style={{ fontWeight: 'bold', fontSize: 14, marginBottom: 10, marginTop: 10 }}>
                                    Periodo:
                                    <Text style={{ fontSize: 14, color: "#701B8C" }}>
                                        {"  "}{this.props.dataInicio ? moment(this.props.dataInicio).format("l") : '-'}
                                    </Text>
                                    <Text style={{ fontSize: 14, color: "#701B8C" }}>
                                        {"   à   "}{this.props.dataFim ? moment(this.props.dataFim).format("l") : '-'}
                                    </Text>
                                </Text>
                            </View>
                            <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D', marginBottom: 10 }}>
                                Total de entregas:
                                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                                    {"  "}{this.props.data.length}
                                </Text>
                            </Text>
                            <Text style={{ fontWeight: 'bold', fontSize: 16, color: '#3D434D' }}>
                                Total faturado:
                                <Text style={{ fontSize: 16, color: "#701B8C" }}>
                                    {"  "}R$ {this.props.totalFaturado}
                                </Text>
                            </Text>
                            <View style={styles.table}>
                                <View style={styles.tableRow}>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Data</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Código pedido</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Cliente</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Entregador</Text>
                                    </View>
                                    <View style={styles.tableCol}>
                                        <Text style={styles.tableCell}>Frete</Text>
                                    </View>
                                </View>
                                {this.props.data.map((pedido, i) => (
                                    <View style={styles.tableRow}>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>
                                                {moment(pedido.agendado ? pedido.dataAgendamento : pedido.createdAt).format("l")}
                                                {" "}{moment(pedido.agendado ? pedido.dataAgendamento : pedido.createdAt).format("LT")}
                                            </Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{pedido.codigo}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{pedido.cliente ? pedido.cliente.nome : ""}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>{pedido.entregador ? pedido.entregador.nome : ""}</Text>
                                        </View>
                                        <View style={styles.tableCol}>
                                            <Text style={styles.tableCell}>R$ {parseFloat(pedido.detalhes_pagamento.frete).toFixed(2).replace('.', ',')}</Text>
                                        </View>
                                    </View>
                                ))}
                            </View>
                        </View>
                        <Text style={{ fontSize: 12, marginTop: 10 }}>
                            {"*Emitido em - "}{moment(Date.now()).format("l")} {moment(Date.now()).format("LT")}
                        </Text>
                    </View>
                </Page>
            </Document>
        );
    }
}

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    container: {
        padding: 20,
        backgroundColor: '#F5F6F8',
        height: '100%',
    },
    title: {
        fontSize: 22,
        color: "#000",
        paddingBottom: 20,
    },
    table: {
        display: "table",
        width: "auto",
        borderStyle: "solid",
        borderWidth: 1,
        borderRightWidth: 0,
        borderBottomWidth: 0,
        marginTop: 20
    },
    tableRow: {
        margin: "auto",
        flexDirection: "row"
    },
    tableCol: {
        width: "20%",
        borderStyle: "solid",
        borderWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 5
    },
    tableCell: {
        margin: "auto",
        fontSize: 10,
        textAlign: 'center'
    }
});